import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  success: '',
  hasNext: false,
  page: 0,
  hasPrev: false,
  totalPages: 0,
  totalResult: 0,
  loading: false,
  processing: false,
  shifts: [],
  bookings: [],
  users:[],
  shiftList:[],
  bookedShift:[],
  error: '',

  shiftAppointments: [],
  loadingShiftAppointments:false,
  errorShiftAppointments: ''
}

const campaignShiftSlice = createSlice({
  name: 'campaignShiftSlice',
  initialState: initialState,
  reducers: {
    getShifts: () => {},
    getUserInfo: () => {},
    getShiftAppointments: () => {},
    createShift: () => {},
    deleteShift: () => {},
    updateShift:() => {},
    setShifts: (state, action) => {
      state.shifts = action.payload
      state.loading = false
    },
    setNewShift: (state, action) => {
      state.shifts = [...state.shifts, action.payload];
    },
    removeShift: (state, action) => {
      state.shifts = state.shifts.filter((shift) => shift.id !== action.payload);
      state.processing = false;
    },
    setUpdatedShift: (state, action) => {
      state.shifts = state.shifts.map((shift) => {
        if(shift.id === action.payload.id){
          return action.payload;
        }else{
          return shift
        }
      })
    },
    setLoading: (state) => {
      state.loading = true
    },
    setShiftAppointments : (state, action) => {
      state.shiftAppointments = action.payload 
      state.loadingShiftAppointments = false;
    },
    setProcessing: (state, action) => {
      state.processing = action.payload ?? true
    },
    setError: (state, action) => {
      state.loading = false
      state.error = action.payload
    },
    setShiftAppointmentLoading: (state) => {
      state.errorShiftAppointments = '';
      state.loadingShiftAppointments = true
    },
    setShiftAppointmentError: (state, action) => {
      state.errorShiftAppointments = action.payload;
      state.loadingShiftAppointments = false;
    }
  },
})

export const {
  getActiveNurses,
  getBookings,
  getShifts,
  getUserInfo,
  getShiftAppointments,
  setShiftAppointments,
  setShiftAppointmentError,
  setShiftAppointmentLoading,
  createShift,
  setError,
  setNewShift,
  setLoading,
  setBookings,
  setUserInfo,
  setCampaings,
  setProcessing,
  setShifts,
  removeBooking,
  removeShift,
  updateShift,
  setUpdatedShift,
  cancelBookings,
} = campaignShiftSlice.actions

export default campaignShiftSlice.reducer;
